export const habaAltText = {
  altText: {
    emptyCart: 'Leerer Warenkorb – noch keine Artikel im Einkaufskorb bei HABA Play',
    orderDetailsTrack: 'LKW-Symbol – steht für Standardversand bei HABA Play',
    personalizationModalPreviewImg: 'Stickerei-Vorschau',
    deliveryLogo: {
      dhl: 'DHL-Logo – Versand mit DHL bei HABA Play',
      hermes: 'Hermes-Logo – Versand mit Hermes bei HABA Play',
      default: 'Animiertes LKW-Symbol – steht für Lieferung bei HABA Play',
    },
    paymentLogo: {
      advancePayment: 'Vorkasse-Symbol – Zahlung per Banküberweisung bei HABA Play',
      ct_creditcard_hop: 'Mastercard- und Visa-Logos – Zahlung mit Kreditkarte bei HABA Play',
      ct_paypal: 'PayPal-Logo – sichere Online-Zahlung bei HABA Play',
      invoice: 'Rechnung-Symbol – Kauf auf Rechnung bei HABA Play',
      fallback: 'Zahlungssymbol – steht für sichere Bezahlung bei HABA Play'
    }
  },
};
